// Cached /me lets the app render the layout from localStorage on boot instead
// of blocking the router guard on a fresh /me. Written in main.js's
// parseUserData on every successful /me; cleared on logout from every sign-out
// path so a previous profile never lingers in storage during the SPA session.
export const USER_CACHE_KEY = 'refrag_user_cache';

// Once a sign-out happens we latch writes off for the rest of this page-load
// session, so a background /me that was already in flight at boot can't resolve
// and repopulate the cache after the user has logged out. A full reload (which
// any logout redirect into a fresh app boot performs) resets this module state.
let writesSuppressed = false;

function removeKey() {
  try {
    localStorage.removeItem(USER_CACHE_KEY);
  } catch (e) {
    // localStorage unavailable — nothing to clear.
  }
}

// Persist the latest /me snapshot, unless a sign-out has latched writes off.
export function writeUserCache(user) {
  if (writesSuppressed) {
    return;
  }
  try {
    localStorage.setItem(USER_CACHE_KEY, JSON.stringify(user));
  } catch (e) {
    // Serialization/quota failure is non-fatal — we just skip caching.
  }
}

// Drop the snapshot without latching (empty /me, corrupt cache, no token at
// boot) — the user may still be authenticated, so future writes stay enabled.
export function dropUserCache() {
  removeKey();
}

// Sign-out: drop the snapshot AND latch off further writes for this session so
// an in-flight /me resolving after logout can't write the stale profile back.
export function clearUserCache() {
  writesSuppressed = true;
  removeKey();
}
